export default Object.freeze({
  BOP_BANNER: 'BOP_BANNER',
  BOP_CAROUSEL: 'BOP_CAROUSEL',
  CATALOGUE_BANNER: 'CATALOGUE_BANNER',
  CATALOGUE_SIDEBAR: 'CATALOGUE_SIDEBAR',
  CATALOGUE_SIDEBAR_RECOMMENDED: 'CATALOGUE_SIDEBAR_RECOMMENDED',
  CATALOGUE_TOP_CAROUSEL: 'CATALOGUE_TOP_CAROUSEL', // key to identify carousel on a website
  CHECKOUT_CONFIRMATION_BANNERS: 'CHECKOUT_CONFIRMATION_BANNERS',
  CHECKOUT_CONFIRMATION_BOTTOM: 'CHECKOUT_CONFIRMATION_BOTTOM',
  LOGGED_OUT_HOMEPAGE: 'LOGGED_OUT_HOMEPAGE',
  MAIN_FOP_LIST: 'MAIN_FOP_LIST',
  OFFERS_BANNER: 'OFFERS_BANNER',
  OFFERS_SIDEBAR: 'OFFERS_SIDEBAR',
  OFFERS_SIDEBAR_RECOMMENDED: 'OFFERS_SIDEBAR_RECOMMENDED',
  OFFER_DETAILS_BANNER: 'OFFER_DETAILS_BANNER',
  OFFER_DETAILS_CAROUSEL: 'OFFER_DETAILS_CAROUSEL',
  OFFER_DETAILS_SIDEBAR: 'OFFER_DETAILS_SIDEBAR',
  OFFER_DETAILS_SIDEBAR_RECOMMENDED: 'OFFER_DETAILS_SIDEBAR_RECOMMENDED',
  SEARCH_BANNER: 'SEARCH_BANNER',
  SEARCH_CAROUSEL: 'SEARCH_CAROUSEL',
  SEARCH_SIDEBAR: 'SEARCH_SIDEBAR',
  SEARCH_SIDEBAR_RECOMMENDED: 'SEARCH_SIDEBAR_RECOMMENDED',
});
